import React, { useState, useEffect, useRef } from 'react';
import { Card, Row, Col, Input, Button, Form, FormGroup, Label, Modal, ModalBody, Table, Alert, CardBody } from 'reactstrap';
import { FaPlus, FaCheck, FaTrash, FaArrowLeft } from 'react-icons/fa';
import { faCommentAlt, faBicycle, faWalking, faMapMarkerAlt, faCheckCircle, FaCreditCard, faShoppingBasket, faPaperPlane, faEnvelope, faSearch, faTruck, faFire, faClipboardList, faClock, faPhone, faMoneyBill } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useParams } from 'react-router-dom';
import RejectQuotationPopup from './RejectQuotationPopup';
import DashboardService from "../dashboard.service";
import AuthService from "../../Authentication/auth.service";
import Alerts from "../../../components/Alerts/alerts";
import { useTranslation } from 'react-i18next';
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../../components/Loaders/DnaLoader";
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DiscountCouponService from "../../DiscountCoupon/Discountcoupons.service";
import {
  faSpinner,
  faBox, faBan, faQuestion
} from '@fortawesome/free-solid-svg-icons';
import { FaDownload } from 'react-icons/fa';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { toWords } from 'number-to-words'
import { io } from 'socket.io-client'

const ViewRfqs = () => {
  const [rfqDetails, setRfqDetails] = useState(null);
  const [orderTrackingDetails, setOrderTrackingDetails] = useState(null);
  const [orderCreditNoteDetails, setOrderCreditNoteDetails] = useState(null);
  const [orderInvoiceDetails, setInvoiceDetails] = useState(null);
  const [orderPaymentDetails, setPaymentDetails] = useState(null);
  const [activeTab, setActiveTab] = useState('details');
  const [loading, setLoading] = useState(true);
  const [isPopupVisible, setPopupVisible] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();
  const sessionID = localStorage.getItem("session-id");
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [returnReason, setReturnReason] = useState('');
  const [logo, setLogo] = useState(localStorage.getItem("system_logo"));
  // Notification helpers and refs
  const canNotify = () => typeof window !== 'undefined' && 'Notification' in window;
  const requestNotifyPermission = async () => {
    try {
      if (!canNotify()) return false;
      if (Notification.permission === 'granted') return true;
      if (Notification.permission !== 'denied') {
        const p = await Notification.requestPermission();
        return p === 'granted';
      }
      return false;
    } catch (_) { return false; }
  };
  const pushNotify = async (title, body) => {
    try {
      const ok = await requestNotifyPermission();
      if (!ok) return;
      new Notification(title, { body, icon: logo || '/favicon.ico' });
    } catch (_) { }
  };
  const lastMessageCountRef = useRef(0);
  const socketRef = useRef(null);

  useEffect(() => {
    fetchRfqDetails();
  }, [id]);

  const fetchRfqDetails = async () => {
    setLoading(true);
    try {
      var payload = {
        functionName: "GetRFQDetails",
        postData: {
          _id: id,
        }
      }

      const response = await DashboardService.GetRFQDetails(payload);
      if (response.data.status) {
        //iph todo: 47
        //console.log("response.data.data", response.data.data)
        setRfqDetails(response?.data?.data?.[0]);
        setReturnReason(rfqDetails?.return_reason || '')
        setOrderTrackingDetails(response?.data?.orderTrackingDetails);
        setOrderCreditNoteDetails(response?.data?.orderCreditNoteDetails);
        setInvoiceDetails(response?.data?.orderInvoiceDetails);
        setPaymentDetails(response?.data?.orderPaymentDetails);

      } else {
        Alerts.swalErrorAlert(response.data.message || t("Failed to fetch Order details"));
      }
    } catch (error) {
      console.error("Error fetching Order details:", error);
      Alerts.swalErrorAlert(t("An error occurred while fetching Order details"));
    } finally {
      setLoading(false);
    }
  };

  const openPopup = () => setPopupVisible(true);
  const closePopup = () => setPopupVisible(false);


  const handleAccept = async () => {
    try {
      setLoading(true);
      var payload = {
        functionName: "AcceptRFQ",
        postData: {
          _id: id,
        }
      }
      const response = await DashboardService.AcceptRFQ(payload);
      if (response.data.status) {
        setLoading(false);
        Alerts.swalSuccessAlert(t("Order Received. Invoice being issued"));
        fetchRfqDetails();
      } else {
        setLoading(false);
        Alerts.swalErrorAlert(response.data.message || t("Failed to accept Order"));
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error accepting Order:", error);
      Alerts.swalErrorAlert(t("An error occurred while accepting the Order"));
    }
  };

  const handleApprove = async () => {
    try {
      setLoading(true);
      var payload = {
        functionName: "ApproveRFQ",
        postData: {
          _id: id,
        }
      }
      const response = await DashboardService.ApproveRFQ(payload);
      if (response.data.status) {
        setLoading(false);
        Alerts.swalSuccessAlert(t("Order Approved Successfully"));
        fetchRfqDetails();
      } else {
        setLoading(false);
        Alerts.swalErrorAlert(response.data.message || t("Failed to Approved Order"));
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error accepting Order:", error);
      Alerts.swalErrorAlert(t("An error occurred while accepting the Order"));
    }
  };

  const renderOrderDetails = () => (
    <div className="item-list mb-3">
      <div className="container mt-4">
        {isPopupVisible && <RejectQuotationPopup quotationId={id} rfq_id={rfqDetails?.rfq_id} onClose={closePopup} fetchRfqDetails={fetchRfqDetails}
        />}


        <LoadingOverlay active={loading ? true : false} spinner={<DNALoader />} >
          <Card className="rfq-card">
            <div className="p-4">
              <Form>
                <Row className="mb-4">
                  <Col md={6}>
                    <FormGroup>
                      <Label for="rfq_date" className="text-muted mb-2">{t("Order Date")}</Label>
                      <Input type="text" id="rfq_date" className="form-select" readOnly value={new Date(rfqDetails?.datetime_added).toLocaleDateString()} />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="status" className="text-muted mb-2">{t("Status")}</Label>
                      <Input type="text" id="status" className="form-select" readOnly value={rfqDetails?.status} />
                    </FormGroup>
                  </Col>
                  {rfqDetails?.status === "rejected" &&
                    <Col md={12}>
                      <FormGroup>
                        <Label for="reason" className="text-muted mb-2">{t("Rejection Reason")}</Label>
                        <Input type="textarea" id="reason" readOnly value={rfqDetails?.reason} />
                      </FormGroup>
                    </Col>
                  }
                </Row>

                <h5 className="mb-3 fw-bold">{t("List of Item(s)")}</h5>
                <div className="item-list mb-3">
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>{t("Item(s) - Brand")}</th>
                        <th>{t("Requested Qty")}</th>
                        <th>{t("UOM")}</th>
                        <th>{t("Unit Price")}</th>
                        <th>{t("Discount")}</th>
                        <th>{t("Batches")}</th>
                        <th>{t("Batch Quantity")}</th>
                        <th>{t("Expiry Date")}</th>
                        <th>{t("Total Price")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {renderItemRows(rfqDetails?.items || [])}
                    </tbody>
                  </Table>
                </div>

                {rfqDetails?.outOfStockItems?.length > 0 && (
                  <Alert color="warning">
                    The following items are out of stock or have insufficient quantity:
                    <ul>
                      {rfqDetails?.outOfStockItems?.map((item, index) => (
                        <li key={index}>
                          {item.item_name}: {item.extra_quantity} units out of stock
                        </li>
                      ))}
                    </ul>
                  </Alert>
                )}


                {rfqDetails?.status !== "Review" ?
                  <div className="totals text-end">
                    {(() => {
                      const { subtotal, discountPercentage, totalAmount } = calculateTotals(rfqDetails?.items || []);
                      return (
                        <>
                          {discountPercentage > 0 ?
                            <>
                              <div className="totals-row">
                                <span>{t("Subtotal")}:</span>
                                <span className="ms-3">RM {subtotal.toFixed(2)}</span>
                              </div>
                              < div className="totals-row">
                                <span>{t(`Discount`)}:</span>
                                <span className="ms-3">{parseFloat(discountPercentage).toFixed(2) || 0}</span>
                              </div>
                              < div className="totals-row total-amount fw-bold">
                                <span>{t("Total Amount")}:</span>
                                <span className="ms-3">RM {parseFloat(totalAmount || 0).toFixed(2)}</span>
                              </div>
                            </>
                            :
                            <>
                              < div className="totals-row total-amount fw-bold">
                                <span>{t("Total Amount")}:</span>
                                //{console.log("totalAmount :- ", totalAmount)}
                                <span className="ms-3">{totalAmount ? `RM ${parseFloat(totalAmount || 0).toFixed(2)}` : ''}</span>
                              </div>
                            </>
                          }
                        </>
                      );
                    })()}
                  </div>
                  : ''}

                {/* Pay Now Button */}
                {(rfqDetails?.status === "accepted" || rfqDetails?.status === "confirmed") &&
                  orderInvoiceDetails?.autoCount_status === 'submitted' &&
                  orderInvoiceDetails?.status !== 'paid' && (
                    <div className="text-center mt-4">
                      <Button
                        className="pay-now-button-bottom"
                        onClick={() => { HandlePayment(orderInvoiceDetails) }}
                        size="lg"
                      >
                        <FontAwesomeIcon icon={faMoneyBill} className="me-2" />
                        {t("Pay Now")}
                      </Button>
                    </div>
                  )}
              </Form>
            </div>
          </Card>
        </LoadingOverlay >
        <style>{`
        .app-main__outer {
          background-color: #f8f9fa;
          min-height: 100vh;
          padding-top: 20px;
        }
        .rfq-card {
          border-radius: 10px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.05);
          border: none;
        }
        .form-select, .form-control {
          border-color: #e0e0e0;
          border-radius: 5px;
          padding: 10px;
        }
        .btn-light {
          background-color: #ffffff;
          border-color: #e0e0e0;
          color: #333;
        }
        .btn-primary {
          background-color: #3D607A;
          border-color: #3D607A;
        }
        .text-muted {
          color: #6c757d !important;
        }
        h4, h5 {
          color: #333;
        }
        .item-list {
          border-top: 1px solid #e0e0e0;
          border-bottom: 1px solid #e0e0e0;
          padding: 20px 0;
        }
        .item-image {
          width: 40px;
          height: 40px;
          object-fit: cover;
          border-radius: 5px;
        }
        .totals {
          margin-top: 20px;
        }
        .totals-row {
          display: flex;
          justify-content: flex-end;
          margin-bottom: 5px;
        }
        .total-amount {
          font-weight: bold;
        }
        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
        }
        .back-button {
          background: none;
          border: none;
          font-size: 20px;
          cursor: pointer;
        }
        .rfq-id {
          font-weight: bold;
          font-size: 1.5rem;
        }
        .actions {
          display: flex;
          gap: 10px;
        }
        .reject-button,
        .accept-button {
          padding: 8px 16px;
          border: none;
          border-radius: 5px;
          cursor: pointer;
        }
        .reject-button {
          background-color: #ffdddd;
          color: #d9534f;
        }
        .accept-button {
          background-color: #5cb85c;
          color: #fff;
        }

      `}</style>
      </div >
    </div>
  );



  const renderCreditNoteTab = () => {
    // Sample data structure
    const creditNote = orderCreditNoteDetails;
    if (!creditNote) return null;

    // Group items by category and filter out items with zero returned quantity
    const groupedItems = creditNote.items?.reduce((acc, item) => {
      if (item.returned_quantity > 0) {
        const category = item.ItemGroup || item.categoryDetails?.Name || '';
        if (!acc[category]) {
          acc[category] = [];
        }
        acc[category].push(item);
      }
      return acc;
    }, {});



    const styles = {
      page: {
        fontFamily: 'Arial, sans-serif',
        fontSize: '15px',
        lineHeight: '1.4',
        color: '#000',
        backgroundColor: '#fff',
        width: '300mm',
        minHeight: '297mm',
        margin: '20px auto',
        paddingBottom: '15mm',
        paddingTop: '1mm',
        paddingLeft: '15mm',
        paddingRight: '15mm',
        boxSizing: 'border-box',
        position: 'relative',
      },
      card: {
        width: '300mm',
        minHeight: '297mm',
        border: 'none',
        boxShadow: 'none'
      },
      header: {
        borderBottom: '1px solid #000',
        paddingBottom: '20px',
        marginBottom: '20px'
      },
      headerContent: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start'
      },
      logo: {
        width: '150px',
        height: 'auto'
      },
      companyInfo: {
        textAlign: 'right'
      },
      companyName: {
        fontSize: '16px',
        fontWeight: 'bold',
        marginBottom: '5px'
      },
      title: {
        fontSize: '16px',
        fontWeight: 'bold',
        marginBottom: '20px'
      },
      table: {
        width: '100%',
        borderCollapse: 'collapse',
        marginBottom: '20px'
      },
      th: {
        borderTop: '1px solid #000',
        borderBottom: '1px solid #000',
        padding: '8px',
        textAlign: 'center'
      },
      td: {
        padding: '8px',
        borderBottom: '1px solid #ddd'
      },
      categoryHeader: {
        backgroundColor: '#f5f5f5',
        padding: '8px',
        fontWeight: 'bold'
      },

      totalSection: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '20px'
      },


      total: {
        marginTop: '40px',
        paddingTop: '20px',
      },

      totalAmountSection: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: '20px',
      },

      totalTextContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        borderBottom: '1px solid #000',
        borderTop: '1px solid #000',
        paddingTop: '5px',
        paddingBottom: '5px',
        fontWeight: 'bold',
        fontSize: '14px',
      },

      totalLabel: {
        fontWeight: 'bold',
      },

      totalValue: {
        fontWeight: 'bold',
      },


      notes: {
        marginBottom: '40px'
      },
      signatures: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '60px'
      },
      signatureLine: {
        borderTop: '1px solid #000',
        width: '200px',
        marginTop: '40px'
      }
    };

    const renderHeader = () => (
      <div style={styles.header}>
        <div style={styles.headerContent}>
          <img src={logo} alt="IPHRx" style={styles.logo} />
          <div style={styles.companyInfo}>
            <div style={styles.companyName}>IPH Pharmaceuticals Sdn.Bhd. (1129802-A)</div>
            <div>323, 1st Floor, Jalan Pudu, 55100 Kuala Lumpur, Wilayah Persekutuan , Malaysia</div>
            <div>Mobile No: 010-8726948</div>
            <div>E-mail: iphrx7@gmail.com</div>
            <div>Website: www.iphrx.com.my</div>
          </div>
        </div>
      </div>
    );

    const renderClientInfo = (pageNumber) => (
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
        <div style={{ maxWidth: '48%' }}>
          <div style={{ fontWeight: 'bold', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {rfqDetails?.userDetails?.[0]?.clinic_name}
          </div>
          <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {rfqDetails?.userDetails?.[0]?.name}
          </div>
          <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {rfqDetails?.userDetails?.[0]?.Address}
          </div>
          <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {rfqDetails?.userDetails?.[0]?.email}
          </div>
          <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {rfqDetails?.userDetails?.[0]?.phone}
          </div>
          <div style={{ marginTop: '10px' }}>
            <div style={{ whiteSpace: 'nowrap' }}>Reason for use:</div>
            <div style={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>{rfqDetails?.reason_of_use}</div>
          </div>
        </div>
        <div style={{ maxWidth: '48%' }}>
          <table>
            <tbody>
              <tr>
                <td style={{ whiteSpace: 'nowrap' }}>Invoice / Poison Order No:</td>
                <td style={{ whiteSpace: 'nowrap' }}>{orderInvoiceDetails?.invoice_number}</td>
              </tr>
              <tr>
                <td style={{ whiteSpace: 'nowrap' }}>Invoice Date:</td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  {orderInvoiceDetails?.datetime_added ? moment(orderInvoiceDetails.datetime_added).format('DD/MM/YYYY') : ''}
                </td>
              </tr>
              <tr>
                <td style={{ whiteSpace: 'nowrap' }}>Order Number:</td>
                <td style={{ whiteSpace: 'nowrap' }}>{orderInvoiceDetails?.order_number || ''}</td>
              </tr>
              <tr>
                <td style={{ whiteSpace: 'nowrap' }}>Order Date:</td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  {orderInvoiceDetails?.datetime_added ? moment(orderInvoiceDetails.datetime_added).format('DD/MM/YYYY') : ''}
                </td>
              </tr>
              <tr>
                <td style={{ whiteSpace: 'nowrap' }}>Credit Term:</td>
                <td style={{ whiteSpace: 'nowrap' }}>{formatPaymentTerm(orderInvoiceDetails?.paymentTerms || rfqDetails?.paymentTerms)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );

    const renderItemsTable = (items, showTotal = false) => (
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>#</th>
            <th style={styles.th}>Description</th>
            <th style={styles.th}>Qty</th>
            <th style={styles.th}>Batch No</th>
            <th style={styles.th}>Expiry</th>
            <th style={styles.th}>U/Price (RM)</th>
            <th style={styles.th}>Discount (RM)</th>
            <th style={styles.th}>Amount (RM)</th>
          </tr>
        </thead>
        <tbody>
          <>
            <tr>
              <td colSpan="8" style={styles.categoryHeader}>POISON</td>
            </tr>
            {Object.entries(groupedItems).map(([category, items], categoryIndex) => (
              <React.Fragment key={categoryIndex}>
                {items.map((item, itemIndex) => (
                  (item.selectedBatches || []).map((batch, batchIndex, arr) => (
                    <tr key={`${categoryIndex}-${itemIndex}-${batchIndex}`} style={batchIndex === (arr.length - 1) ? { borderBottom: 'none' } : {}}>
                      {batchIndex === 0 && (
                        <td rowSpan={arr.length} style={{ textAlign: 'center' }}>{itemIndex + 1}</td>
                      )}
                      {batchIndex === 0 && (
                        <td rowSpan={arr.length} style={{ maxWidth: '55%', whiteSpace: 'normal', wordBreak: 'break-word' }}>
                          <strong>{item.item_name}</strong>
                        </td>
                      )}
                      <td style={{ textAlign: 'center' }}>{batch.quantity}</td>
                      <td style={{ textAlign: 'center' }}>{batch.batch_number}</td>
                      <td style={{ textAlign: 'center' }}>{batch?.expiry ? moment(batch.expiry).format('DD/MM/YYYY') : ''}</td>
                      <td style={{ textAlign: 'center' }}>{parseFloat(item.price).toFixed(2)}</td>
                      <td style={{ textAlign: 'center' }}>
                        {item?.discount ? `${(((item.discount || 0)) / 100 * (item.price || 0) * (batch.quantity || 0)).toFixed(2)} (${item.discount}%)` : '-'}
                      </td>
                      <td style={{ textAlign: 'center' }}>{(
                        (parseFloat(item.price || 0) * parseFloat(batch.quantity || 0)) -
                        (((item.discount || 0) / 100) * (item.price || 0) * (batch.quantity || 0))
                      ).toFixed(2)}</td>
                    </tr>
                  ))
                ))}
              </React.Fragment>
            ))}
          </>
        </tbody>
      </table >
    );

    const renderTotal = () => (
      <div style={styles.total}>
        <div style={styles.totalAmountSection}>
          {(() => {
            const items = (orderInvoiceDetails && orderInvoiceDetails.item) ? orderInvoiceDetails.item : [];
            const totals = items.reduce((acc, item) => {
              const batches = item.selectedBatches || [];
              batches.forEach((b) => {
                const line = (parseFloat(item.price || 0) * parseFloat(b.quantity || 0));
                const disc = ((item.discount || 0) / 100) * (item.price || 0) * (b.quantity || 0);
                acc.subtotal += line;
                acc.discount += disc;
              });
              return acc;
            }, { subtotal: 0, discount: 0 });
            const total = totals.subtotal - totals.discount;
            const toWords = require('number-to-words').toWords;
            const [ringgit, sen] = parseFloat(total).toFixed(2).split(".");
            const ringgitWords = toWords(parseInt(ringgit)).toUpperCase();
            const senWords = parseInt(sen) > 0 ? ` AND CENTS ${toWords(parseInt(sen)).toUpperCase()}` : '';
            const totalInWords = `${ringgitWords}${senWords}`;
            return (
              <>
                <div style={{ marginBottom: '8px' }}>Subtotal: RM {totals.subtotal.toFixed(2)}</div>
                <div style={{ marginBottom: '8px' }}>Discount: RM {totals.discount.toFixed(2)}</div>
                <div style={styles.totalRowCombined}>
                  <div style={styles.totalWords}>RINGGIT MALAYSIA {totalInWords} ONLY</div>
                  <div style={styles.totalLabelWithBox}>
                    <span style={styles.totalLabel}>Total</span>
                    <span style={styles.totalValueBox}>RM {total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                  </div>
                </div>
              </>
            );
          })()}
        </div>
      </div>
    );

    const renderFooter = () => (
      <div>
        <div style={styles.totalSection}>
          <div>
            <div>Total Amount Payable :</div>
            <div style={{ fontSize: '14px', fontWeight: 'bold' }}>RM {creditNote.total_amount}</div>
          </div>
        </div>

        <div style={{ marginBottom: '20px' }}>
          <div>Issued by:</div>
          <div style={styles.signatureLine}></div>
        </div>

        <div style={styles.notes}>
          <div>Notes :</div>
          <ol>
            <li>
              Please issue cheque made payable to : <strong>IPH PHARMACEUTICALS SDN BHD</strong><br />
              or transfer to our Maybank account no. : <strong>514048620937</strong><br />
              and inform us the details by email : <strong>finance.iphpsb@gmail.com</strong>
            </li>
            <li>Goods sold are not returnable or refundable.</li>
            <li>
              No complaints will be considered unless notified within (2) day upon receipt of the above
              mentioned items
            </li>
          </ol>
        </div>
      </div>
    );

    return (
      <div className="credit-note-container">
        <Card style={styles.card} className="invoice-card" id="creditNoteContent">
          <div style={styles.page} data-page="1">
            {renderHeader()}
            <div style={styles.title}>Credit Note</div>
            {renderClientInfo(1)}
            {renderItemsTable(
              {
                np: groupedItems,
                poison: groupedItems
              },
            )}
            {renderTotal()}
            {renderFooter()}
          </div>
        </Card>
      </div>
    );
  };







  // Helper function to calculate total amount
  const getTotalAmount = (groupedItems) => {
    let total = 0
    Object.entries(groupedItems).forEach(([category, items]) => {
      items.forEach((item) => {
        total += Number.parseFloat(item.price * item.returned_quantity)
      })
    })
    return total
  }

  const amountInWords = (amount) => {
    const rounded = Math.round(amount)
    return `${toWords(rounded)} only`
  }



  const downloadCreditNote = () => {
    const input = document.getElementById('creditNoteContent');
    setLoading(true);
    html2canvas(input)
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save(`CreditNote.pdf`);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
        setLoading(false);
        Alerts.swalErrorAlert(t("Failed to download credit note"));
      });
  };



  const renderReturnTab = () => {
    if (!rfqDetails) return null;

    const handleItemChange = (itemIndex, batchIndex, value) => {
      const newItems = [...rfqDetails.items];
      newItems[itemIndex].selectedBatches[batchIndex].returned_quantity = parseInt(value);
      setRfqDetails({ ...rfqDetails, items: newItems });
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
      setLoading(true);
      if (!returnReason.trim()) {
        Alerts.swalErrorAlert(t("Please provide a reason for return"));
        setLoading(false);
        return;
      }

      try {
        const rfqData = {
          _id: id,
          items: (() => {
            for (const item of rfqDetails.items) {
              for (const batch of item.selectedBatches) {
                if (!batch.returned_quantity || batch.returned_quantity === 0) {
                  //iph todo: 47
                  //console.log("Returned quantity must be greater than 0 for all batches")
                  Alerts.swalErrorAlert(t("Returned quantity must be greater than 0 for all batches"));
                  setLoading(false);
                  return;
                }
              }
            }
            return rfqDetails.items.map(item => ({
              category: item.category,
              item: item.item,
              selectedBatches: item.selectedBatches.map(batch => ({
                batchId: batch.batchId,
                returned_quantity: batch.returned_quantity
              }))
            }));
          })(),
          user_id: rfqDetails.user_id,
          return_reason: returnReason
        };
        const response = await DashboardService.ReturnRFQ(rfqData);
        if (response.data.status) {
          Alerts.swalSuccessAlert(t("Items returned successfully"));
          fetchRfqDetails();
        } else {
          Alerts.swalErrorAlert(response.data.message || t("Failed to return items"));
        }
      } catch (error) {
        Alerts.swalErrorAlert(t("Failed to return (Add proper quantity)"));
      } finally {
        setLoading(false);
      }
    };

    return (
      <div className="return-tab-container">
        <Card className="return-card">
          <div className="p-4">
            <Form onSubmit={handleSubmit}>
              <div className="item-list mb-3">
                <Label for="returnReason">{t("Reason for Return")}</Label>
                <FormGroup className="mb-3">
                  <Input
                    type="textarea"
                    name="returnReason"
                    id="returnReason"
                    style={{ backgroundColor: "white" }}
                    disabled={rfqDetails?.return_status === "accepted"}
                    defaultValue={rfqDetails?.return_reason || returnReason}
                    onChange={(e) => setReturnReason(e.target.value)}
                    placeholder={t("Please provide a reason for returning the items")}
                    rows="3"
                    required
                  />
                </FormGroup>
                <Table responsive>
                  <thead>
                    <tr>
                      <th>{t("Item(s)")}</th>
                      <th>{t("Batch")}</th>
                      <th>{t("Expiry")}</th>
                      <th>{t("Order Quantity")}</th>
                      <th>{t("Returned Quantity")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rfqDetails.items.map((item, itemIndex) => (
                      item.selectedBatches.map((batch, batchIndex) => (
                        <tr key={`${itemIndex}-${batchIndex}`}>
                          <td>{item.itemDetails.item_name}</td>
                          <td>{batch.batch_number}</td>
                          <td>{batch?.expiry ? moment(batch.expiry).format("DD-MM-YYYY") : '---'}</td>
                          <td>{batch.quantity}</td>
                          <td>
                            <Input
                              type="number"
                              min="1"
                              max={batch.quantity}
                              disabled={orderCreditNoteDetails}
                              value={batch.returned_quantity || ''}
                              style={{ backgroundColor: 'white' }}
                              onChange={(e) => {
                                const value = parseInt(e.target.value, 10);
                                if (value > 0 && value <= batch.quantity) {
                                  handleItemChange(itemIndex, batchIndex, value);
                                } else {
                                  Alerts.swalErrorAlert(t("Returned quantity must be greater than 0 and less than or equal to the batch quantity"));
                                }
                              }}
                              className="return-quantity-input"
                            />
                          </td>
                        </tr>
                      ))
                    ))}
                  </tbody>
                </Table>
              </div>
              <div className="d-flex">
                {!orderCreditNoteDetails &&
                  <Button type="submit" color="primary" className="px-3">
                    <FaCheck className="me-2" /> {t("Return Items")}
                  </Button>
                }
              </div>
            </Form>
          </div>
        </Card>
      </div>
    );
  };



  const HandlePayment = (row) => {
    //iph todo: 47
    //console.log("row", row);
    var getData = {
      functionName: "OnlinePayment",
      row: row,
      invoice_id: row?._id ? row?._id : null,
      amount: parseFloat(row.total_amount).toFixed(2),
      invoice_number: row.invoice_number,
      business_id: row?.business_id
    }
    //iph todo: 47
    //console.log("getData", getData);
    setLoading(true);
    DashboardService.OnlinePayment(getData).then((response) => {
      //iph todo: 47
      //console.log(response);
      setLoading(false);
      if (response.status === 200) {
        //iph todo: 47
        //console.log(response);
        window.open(response.data.data, '_blank');
        //iph todo: 47
        //console.log('Response : ', response);
      } else if (response.status === 401) {
        AuthService.logout();
        navigate("/login");
        window.location.reload();
      } else {
        window.open(response.data.data, '_blank');
      }
    },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        //iph todo: 47
        //console.log("Net:-", errContent);
        if (errContent) {
          Alerts.swalErrorAlert(errContent);
        } else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."));
        }
      })
  }

  const downloadPaymentReceipt = () => {
    const input = document.getElementById('paymentReceiptContent');
    // Do NOT enable LoadingOverlay during capture; it gets rendered into the canvas as a grey layer
    html2canvas(input, { backgroundColor: '#ffffff', scale: 2, useCORS: true })
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save(`payment_receipt.pdf`);
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
        Alerts.swalErrorAlert(t("Failed to download payment receipt"));
      });
  };

  const downloadInvoice = () => {
    if (!orderInvoiceDetails) return null;

    const invoice = orderInvoiceDetails;
    //iph todo: 47
    //console.log("invoice invoice", invoice)

    // Both renderNPDetails and renderPOISONDetails use 'invoiceContent' ID
    const input = document.getElementById('invoiceContent');

    if (!input) {
      Alerts.swalErrorAlert(t("Invoice content not found. Please try again."));
      return;
    }

    setLoading(true);
    html2canvas(input)
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save(`invoice.pdf`);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
        setLoading(false);
        Alerts.swalErrorAlert(t("Failed to download invoice"));
      });
  };



  const renderInvoiceContent = () => {
    if (!orderInvoiceDetails) return null;

    const invoice = orderInvoiceDetails;
    //iph todo: 47
    //console.log("invoice invoice", invoice)

    // Ensure `invoice.item` is defined and has data
    const items = invoice.item || [];
    if (items.length === 0) return renderNPDetails(); // Default case
    //iph todo: 47
    //console.log("items items", items)

    const allItemsArePoison = items.every(item => item.ItemGroup && item.ItemGroup.toLowerCase().includes('poison'));
    //iph todo: 47
    //console.log("allItemsArePoison", allItemsArePoison)

    if (allItemsArePoison) {
      return renderPOISONDetails();
    }

    // If all items are NP, render NP details, otherwise default to NP
    return renderNPDetails();
  };



  const renderNPDetails = () => {
    // Sample data structure
    const invoice = orderInvoiceDetails;
    if (!invoice) return null;

    // const allItemsArePoison = items.every(item => item.ItemGroup === 'POISON');
    // const allItemsAreNP = items.every(item => item.ItemGroup === 'NP');

    const groupedItems = invoice.item?.reduce((acc, item) => {
      const group = item.ItemGroup || '';
      if (!acc[group]) {
        acc[group] = [];
      }
      acc[group].push(item);
      return acc;
    }, {});

    //iph todo: 47
    //console.log("grouped Items :- ", groupedItems)

    const styles = {
      page: {
        fontFamily: 'Arial, sans-serif',
        fontSize: '15px',
        lineHeight: '1.4',
        color: '#000',
        backgroundColor: '#fff',
        width: '300mm',
        minHeight: '297mm',
        margin: '20px auto',
        paddingBottom: '15mm',
        paddingTop: '1mm',
        paddingLeft: '15mm',
        paddingRight: '15mm',
        boxSizing: 'border-box',
        position: 'relative',
      },
      card: {
        width: '300mm',
        minHeight: '297mm',
        border: 'none',
        boxShadow: 'none'
      },
      header: {
        borderBottom: "1px solid #000",
        paddingBottom: "10px",
        marginBottom: "10px",
      },
      headerContent: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
      },
      logo: {
        width: '150px',
        height: 'auto'
      },
      companyInfo: {
        fontSize: "18px",
        lineHeight: "1.3",
        textAlign: "center",
      },
      // companyInfo: {
      //   textAlign: 'right'
      // },
      // companyName: {
      //   fontSize: '16px',
      //   fontWeight: 'bold',
      //   marginBottom: '5px'
      // },
      // title: {
      //   fontSize: '16px',
      //   fontWeight: 'bold',
      //   marginBottom: '20px'
      // },

      companyName: {
        fontSize: "25px",
        fontWeight: "bold",
        marginBottom: "3px",
      },
      rfq: {
        fontSize: "15px",
        fontWeight: 'normal',
        marginBottom: "3px",
      },
      title: {
        fontSize: "20px",
        fontWeight: "bold",
        marginBottom: "15px",
        textAlign: "center",
      },
      table: {
        width: '100%',
        borderCollapse: 'collapse',
        marginBottom: '20px'
      },
      th: {
        borderTop: '1px solid #000',
        borderBottom: '1px solid #000',
        padding: '8px',
        textAlign: 'center'
      },
      td: {
        padding: '8px',
        borderBottom: '1px solid #ddd'
      },
      categoryHeader: {
        backgroundColor: '#f5f5f5',
        padding: '8px',
        fontWeight: 'bold'
      },
      footer: {
      },
      totalSection: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '20px'
      },

      total: {
        marginTop: '40px',
        paddingTop: '20px',
      },

      totalAmountSection: {
        marginBottom: '20px',
      },

      totalRowCombined: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderTop: '1px solid #000',
        borderBottom: '1px solid #000',
        padding: '6px 0',
        fontWeight: 'bold',
        fontSize: '14px',
      },

      totalWords: {
        width: '75%',
        textTransform: 'uppercase',
      },

      totalLabelWithBox: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
      },

      totalLabel: {
        fontWeight: 'bold',
      },

      totalValueBox: {
        border: '1px solid #000',
        padding: '4px 12px',
        fontWeight: 'bold',
      },



      notes: {
        marginBottom: '0px'
      },
      signatures: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '60px'
      },
      signatureLine: {
        borderTop: '1px solid #000',
        width: '200px',
        marginTop: '40px'
      }
    };

    const renderHeader = () => (
      <div style={styles.header}>
        <div style={styles.headerContent}>
          <div style={styles.companyInfo}>
            <div style={{ ...styles.companyName, display: 'inline' }}>IPH Pharmaceuticals Sdn.Bhd. <div style={{ ...styles.rfq, display: 'inline' }}>(1129802-A)</div></div>
            <div>323, 1st Floor, Jalan Pudu, 55100 Kuala Lumpur, Wilayah Persekutuan , Malaysia</div>
            <div>Tel: 010-8726948</div>
            <div>TIN : C23874076050</div>

          </div>
        </div>
      </div>
    );

    const renderClientInfo = (pageNumber) => (
      <>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
          <div style={{ maxWidth: '48%' }}>
            <tr>
              <td style={{ whiteSpace: 'nowrap' }}>Debtor Code :</td>
              <td style={{ whiteSpace: 'nowrap' }}>{rfqDetails?.userDetails?.[0]?.AccNo}</td>
            </tr>
            <div style={{ fontWeight: 'bold', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {rfqDetails?.userDetails?.[0]?.clinic_name}
            </div>
            <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {rfqDetails?.userDetails?.[0]?.name}
            </div>
            <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {rfqDetails?.userDetails?.[0]?.Address}
            </div>
          </div>
          <div style={{ maxWidth: '48%' }}>
            <table>
              <tbody>
                <tr>
                  <td style={{ whiteSpace: 'nowrap' }}>Invoice / Poison Order No:</td>
                  <td style={{ whiteSpace: 'nowrap' }}>{invoice.invoice_number}</td>
                </tr>
                <tr>
                  <td style={{ whiteSpace: 'nowrap' }}>Invoice Date:</td>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    {moment(invoice.datetime_added).format('DD/MM/YYYY')}
                  </td>
                </tr>
                <tr>
                  <td style={{ whiteSpace: 'nowrap' }}>Order Number:</td>
                  <td style={{ whiteSpace: 'nowrap' }}>{invoice?.order_number || ''}</td>
                </tr>
                <tr>
                  <td style={{ whiteSpace: 'nowrap' }}>Order Date:</td>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    {moment(invoice.datetime_added).format('DD/MM/YYYY') || ''}
                  </td>
                </tr>
                <tr>
                  <td style={{ whiteSpace: 'nowrap' }}>Credit Term:</td>
                  <td style={{ whiteSpace: 'nowrap' }}>{formatPaymentTerm(orderInvoiceDetails?.paymentTerms || rfqDetails?.paymentTerms)}</td>
                </tr>
                {/* <tr>
                 <td style={{ whiteSpace: 'nowrap' }}>Page:</td>
                 <td style={{ whiteSpace: 'nowrap' }}>{pageNumber} of 2</td>
               </tr> */}
              </tbody>
            </table>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ maxWidth: '48%' }}>
            <tr>
              <td style={{ whiteSpace: 'nowrap' }}>Tel :</td>
              <td style={{ whiteSpace: 'nowrap' }}>{rfqDetails?.userDetails?.[0]?.phone}</td>
            </tr>
          </div>
          <div style={{ maxWidth: '48%' }}>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
          <div style={{ maxWidth: '60%' }}>
            <tr>
              <div>
                <div style={{ whiteSpace: 'nowrap' }}>Reason for use:</div>
                <div style={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>{rfqDetails?.reason_of_use}</div>
              </div>
            </tr>
          </div>
          <div style={{ maxWidth: '40%' }}>
          </div>
        </div>
      </>
    );

    const renderItemsTable = (items, showTotal = false) => {
      const headerThStyle = { ...styles.th };
      const descriptionTdStyle = { maxWidth: '55%', whiteSpace: 'normal', wordBreak: 'break-word' };
      return (
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={headerThStyle}>#</th>
              <th style={headerThStyle}>Description</th>
              <th style={headerThStyle}>Qty</th>
              <th style={headerThStyle}>Batch No</th>
              <th style={headerThStyle}>Expiry</th>
              <th style={headerThStyle}>U/Price (RM)</th>
              <th style={headerThStyle}>Discount (RM)</th>
              <th style={headerThStyle}>Amount (RM)</th>
            </tr>
          </thead>
          <tbody>
            <>
              {Object.entries(groupedItems).map(([category, items], categoryIndex) => (
                <React.Fragment key={categoryIndex}>
                  <tr>
                    <td colSpan="8" style={styles.categoryHeader}>{(category || 'NP - Non-Poison').toString().toUpperCase()}</td>
                  </tr>
                  {items.map((item, itemIndex) => {
                    const batches = item.selectedBatches || [];
                    const isLastBatch = (idx) => idx === (batches.length - 1);
                    return batches.map((batch, batchIndex) => (
                      <tr key={`${categoryIndex}-${itemIndex}-${batchIndex}`} style={isLastBatch(batchIndex) ? { borderBottom: 'none' } : {}}>
                        {batchIndex === 0 && (
                          <td rowSpan={batches.length} style={{ textAlign: 'center' }}>{itemIndex + 1}</td>
                        )}
                        {batchIndex === 0 && (
                          <td rowSpan={batches.length} style={descriptionTdStyle}>
                            <strong>{item.item_name}</strong>
                          </td>
                        )}
                        <td style={{ textAlign: 'center' }}>{batch.quantity}</td>
                        <td style={{ textAlign: 'center' }}>{batch.batch_number}</td>
                        <td style={{ textAlign: 'center' }}>{batch?.expiry ? moment(batch?.expiry).format('DD/MM/YYYY') : ''}</td>
                        <td style={{ textAlign: 'center' }}>{parseFloat(item.price).toFixed(2)}</td>
                        <td style={{ textAlign: 'center' }}>
                          {item?.discount ? `${(((item.discount || 0) / 100) * (item.price || 0) * (batch.quantity || 0)).toFixed(2)} (${item.discount}%)` : '-'}
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {(
                            (parseFloat(item.price || 0) * parseFloat(batch.quantity || 0)) -
                            (((item.discount || 0) / 100) * (item.price || 0) * (batch.quantity || 0))
                          ).toFixed(2)}
                        </td>
                      </tr>
                    ));
                  })}
                </React.Fragment>
              ))}
            </>
          </tbody>
        </table>
      );
    };

    function convertAmountToWords(amount) {
      //iph todo: 47
      //console.log("amount");
      const toWords = require('number-to-words').toWords;

      const [ringgit, sen] = parseFloat(amount).toFixed(2).split(".");

      const ringgitWords = toWords(parseInt(ringgit)).toUpperCase();
      const senWords = parseInt(sen) > 0 ? ` AND CENTS ${toWords(parseInt(sen)).toUpperCase()}` : '';

      return `${ringgitWords}${senWords}`;
    }

    const renderTotal = () => {
      const items = invoice.item || [];
      const totals = items.reduce((acc, item) => {
        const batches = item.selectedBatches || [];
        batches.forEach((b) => {
          const line = (parseFloat(item.price || 0) * parseFloat(b.quantity || 0));
          const disc = ((item.discount || 0) / 100) * (item.price || 0) * (b.quantity || 0);
          acc.subtotal += line;
          acc.discount += disc;
        });
        return acc;
      }, { subtotal: 0, discount: 0 });
      const total = totals.subtotal - totals.discount;
      const totalInWords = convertAmountToWords(total);

      return (
        <div style={styles.total}>
          <div style={styles.totalAmountSection}>
            <div style={styles.totalRowCombined}>
              <div style={styles.totalWords}>RINGGIT MALAYSIA {totalInWords} ONLY</div>
              <div style={styles.totalLabelWithBox}>
                <span style={styles.totalLabel}>Total</span>
                <span style={styles.totalValueBox}>RM {total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
              </div>
            </div>
          </div>
        </div>
      );
    };

    const renderFooter = () => (
      <div style={styles.footer}>
        <div style={styles.totalSection}>
          {(() => {
            const items = (invoice && invoice.item) ? invoice.item : [];
            const totals = items.reduce((acc, item) => {
              const batches = item.selectedBatches || [];
              batches.forEach((b) => {
                const line = (parseFloat(item.price || 0) * parseFloat(b.quantity || 0));
                const disc = ((item.discount || 0) / 100) * (item.price || 0) * (b.quantity || 0);
                acc.subtotal += line;
                acc.discount += disc;
              });
              return acc;
            }, { subtotal: 0, discount: 0 });
            const total = totals.subtotal - totals.discount;
            return (
              <div>
                <div>Subtotal: <strong>RM {totals.subtotal.toFixed(2)}</strong></div>
                <div>Discount: <strong>RM {totals.discount.toFixed(2)}</strong></div>
                <div style={{ marginTop: '6px' }}>Total Amount Payable : <strong>RM {total.toFixed(2)}</strong></div>
              </div>
            );
          })()}
        </div>

        <div style={{ marginBottom: '20px' }}>
          <div>Issued by:</div>
          <div style={styles.signatureLine}></div>
        </div>

        <div style={styles.notes}>
          <div>Notes :</div>
          <ol>
            <li>
              Please issue cheque made payable to : <strong>IPH PHARMACEUTICALS SDN BHD</strong><br />
              or transfer to our Maybank account no. : <strong>514048620937</strong><br />
              and inform us the details by email : <strong>finance.iphpsb@gmail.com</strong>
            </li>
            <li>Goods sold are not returnable or refundable.</li>
            <li>
              No complaints will be considered unless notified within (2) day upon receipt of the above
              mentioned items
            </li>
          </ol>
        </div>
      </div>
    );

    return (
      <>
        <div className="invoice-container">
          <Card style={styles.card} className="invoice-card" id="invoiceContent">
            <div style={styles.page} data-page="1">
              {renderHeader()}
              <div style={styles.title}>INVOICE / DELIVERY ORDER</div>
              {renderClientInfo(1)}
              {renderItemsTable(
                {
                  np: groupedItems,
                  poison: groupedItems
                },
              )}
              {renderTotal()}
              {renderFooter()}
            </div>
          </Card>
        </div>
        {(orderInvoiceDetails?.autoCount_status === 'submitted' && orderInvoiceDetails?.status !== 'paid') && (
          <div className="text-center mt-4">
            <Button
              className="pay-now-button-bottom"
              onClick={() => { HandlePayment(orderInvoiceDetails) }}
              size="lg"
            >
              <FontAwesomeIcon icon={faMoneyBill} className="me-2" />
              {t("Pay Now")}
            </Button>
          </div>
        )}
      </>
    );
  };

  const renderPOISONDetails = () => {
    // Sample data structure
    const invoice = orderInvoiceDetails;
    if (!invoice) return null;

    // Group items by category
    const groupedItems = invoice.item?.reduce((acc, item) => {
      const category = item.ItemGroup || item.categoryDetails?.Name || '';
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push(item);
      return acc;
    }, {});


    const styles = {
      page: {
        fontFamily: 'Arial, sans-serif',
        fontSize: '15px',
        lineHeight: '1.4',
        color: '#000',
        backgroundColor: '#fff',
        width: '300mm',
        minHeight: '297mm',
        margin: '20px auto',
        paddingBottom: '15mm',
        paddingTop: '1mm',
        paddingLeft: '15mm',
        paddingRight: '15mm',
        boxSizing: 'border-box',
        position: 'relative',
      },
      card: {
        width: '300mm',
        minHeight: '297mm',
        border: 'none',
        boxShadow: 'none'
      },
      header: {
        borderBottom: '1px solid #000',
        paddingBottom: '20px',
        marginBottom: '20px'
      },
      headerContent: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start'
      },
      logo: {
        width: '150px',
        height: 'auto'
      },
      companyInfo: {
        textAlign: 'right'
      },
      companyName: {
        fontSize: '16px',
        fontWeight: 'bold',
        marginBottom: '5px'
      },
      title: {
        fontSize: '16px',
        fontWeight: 'bold',
        marginBottom: '0px'
      },
      table: {
        width: '100%',
        borderCollapse: 'collapse',
        marginBottom: '20px'
      },
      th: {
        borderTop: '1px solid #000',
        borderBottom: '1px solid #000',
        padding: '8px',
        textAlign: 'left'
      },
      td: {
        padding: '8px',
        borderBottom: '1px solid #ddd'
      },
      categoryHeader: {
        // backgroundColor: '#f5f5f5',
        padding: '8px',
        fontWeight: 'bold'
      },
      footer: {
      },
      totalSection: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '20px'
      },
      total: {
        marginTop: '40px',
        paddingTop: '20px',
      },

      totalAmountSection: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: '20px',
      },

      totalTextContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '62px',
        borderBottom: '1px solid #000',
        borderTop: '1px solid #000',
        paddingTop: '5px',
        paddingBottom: '5px',
        fontWeight: 'bold',
        fontSize: '14px',
      },

      totalLabel: {
        fontWeight: 'bold',
      },

      totalValue: {
        fontWeight: 'bold',
      },
      notes: {
        marginBottom: '40px'
      },
      signatures: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '60px'
      },
      signatureLine: {
        borderTop: '1px solid #000',
        width: '200px',
        marginTop: '40px'
      }
    };

    const renderHeader = () => (
      <div style={styles.header}>
        <div style={styles.headerContent}>
          <img src={logo} alt="IPHRx" style={styles.logo} />
          <div style={styles.companyInfo}>
            <div style={styles.companyName}>IPH Pharmaceuticals Sdn.Bhd. (1129802-A)</div>
            <div>323, 1st Floor, Jalan Pudu, 55100 Kuala Lumpur, Wilayah Persekutuan , Malaysia</div>
            <div>Mobile No: 010-8726948</div>
            <div>E-mail: iphrx7@gmail.com</div>
            <div>Website: www.iphrx.com.my</div>
          </div>
        </div>
      </div>
    );

    const renderClientInfo = (pageNumber) => (
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
        <div style={{ maxWidth: '48%' }}>
          <div style={{ fontWeight: 'bold', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {rfqDetails?.userDetails?.[0]?.clinic_name}
          </div>
          <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {rfqDetails?.userDetails?.[0]?.name}
          </div>
          <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {rfqDetails?.userDetails?.[0]?.Address}
          </div>
          <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {rfqDetails?.userDetails?.[0]?.email}
          </div>
          <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {rfqDetails?.userDetails?.[0]?.phone}
          </div>
          <div style={{ marginTop: '10px' }}>
            <div style={{ whiteSpace: 'nowrap' }}>Reason for use:</div>
            <div style={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>{rfqDetails?.reason_of_use}</div>
          </div>
        </div>
        <div style={{ maxWidth: '48%' }}>
          <table>
            <tbody>
              <tr>
                <td style={{ whiteSpace: 'nowrap' }}>Invoice / Poison Order No:</td>
                <td style={{ whiteSpace: 'nowrap' }}>{invoice.invoice_number}</td>
              </tr>
              <tr>
                <td style={{ whiteSpace: 'nowrap' }}>Invoice Date:</td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  {moment(invoice.datetime_added).format('DD/MM/YYYY')}
                </td>
              </tr>
              <tr>
                <td style={{ whiteSpace: 'nowrap' }}>Order Number:</td>
                <td style={{ whiteSpace: 'nowrap' }}>{invoice?.order_number || ''}</td>
              </tr>
              <tr>
                <td style={{ whiteSpace: 'nowrap' }}>Order Date:</td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  {moment(invoice.datetime_added).format('DD/MM/YYYY') || ''}
                </td>
              </tr>
              <tr>
                <td style={{ whiteSpace: 'nowrap' }}>Credit Term:</td>
                <td style={{ whiteSpace: 'nowrap' }}>{formatPaymentTerm(orderInvoiceDetails?.paymentTerms || rfqDetails?.paymentTerms)}</td>
              </tr>
              {/* <tr>
                 <td style={{ whiteSpace: 'nowrap' }}>Page:</td>
                 <td style={{ whiteSpace: 'nowrap' }}>{pageNumber} of 2</td>
               </tr> */}
            </tbody>
          </table>
        </div>
      </div>


    );

    const renderItemsTable = (items, showTotal = false) => (
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>Item</th>
            <th style={styles.th}>Description</th>
            <th style={styles.th}>Qty</th>
            <th style={styles.th}>Batch No</th>
            <th style={styles.th}>Expiry</th>
            <th style={styles.th}>U/Price (RM)</th>
            <th style={styles.th}>Discount (RM)</th>
            <th style={styles.th}>Amount (RM)</th>
          </tr>
        </thead>
        <tbody>
          <>
            <tr>
              <td colSpan="8" style={styles.categoryHeader}>POISON</td>
            </tr>
            {Object.entries(groupedItems).map(([category, items], categoryIndex) => (
              <React.Fragment key={categoryIndex}>
                {items.map((item, itemIndex) => (
                  (item.selectedBatches || []).map((batch, batchIndex, arr) => (
                    <tr key={`${categoryIndex}-${itemIndex}-${batchIndex}`} style={batchIndex === (arr.length - 1) ? { borderBottom: 'none' } : {}}>
                      {batchIndex === 0 && (
                        <td rowSpan={arr.length} style={{ textAlign: 'center' }}>{itemIndex + 1}</td>
                      )}
                      {batchIndex === 0 && (
                        <td rowSpan={arr.length} style={{ maxWidth: '55%', whiteSpace: 'normal', wordBreak: 'break-word' }}>
                          <strong>{item.item_name}</strong>
                        </td>
                      )}
                      <td style={{ textAlign: 'center' }}>{batch.quantity}</td>
                      <td style={{ textAlign: 'center' }}>{batch.batch_number}</td>
                      <td style={{ textAlign: 'center' }}>{batch?.expiry ? moment(batch.expiry).format('DD/MM/YYYY') : ''}</td>
                      <td style={{ textAlign: 'center' }}>{parseFloat(item.price).toFixed(2)}</td>
                      <td style={{ textAlign: 'center' }}>
                        {item?.discount ? `${(((item.discount || 0)) / 100 * (item.price || 0) * (batch.quantity || 0)).toFixed(2)} (${item.discount}%)` : '-'}
                      </td>
                      <td style={{ textAlign: 'center' }}>{(
                        (parseFloat(item.price || 0) * parseFloat(batch.quantity || 0)) -
                        (((item.discount || 0) / 100) * (item.price || 0) * (batch.quantity || 0))
                      ).toFixed(2)}</td>
                    </tr>
                  ))
                ))}
              </React.Fragment>
            ))}
          </>
        </tbody>
      </table >
    );

    const renderTotal = () => (
      <div style={styles.total}>
        <div style={styles.totalAmountSection}>
          {(() => {
            const items = invoice.item || [];
            const totals = items.reduce((acc, item) => {
              const batches = item.selectedBatches || [];
              batches.forEach((b) => {
                const line = (parseFloat(item.price || 0) * parseFloat(b.quantity || 0));
                const disc = ((item.discount || 0) / 100) * (item.price || 0) * (b.quantity || 0);
                acc.subtotal += line;
                acc.discount += disc;
              });
              return acc;
            }, { subtotal: 0, discount: 0 });
            const total = totals.subtotal - totals.discount;
            return (
              <>
                <div style={styles.totalTextContainer}>
                  <span style={styles.totalLabel}>Total &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                  <span style={styles.totalValue}>&nbsp;RM {total.toFixed(2)}</span>
                </div>
              </>
            );
          })()}
        </div>
      </div>
    );

    const renderFooter = () => (
      <div style={styles.footer}>
        <div style={styles.totalSection}>
          {(() => {
            const items = (invoice && invoice.item) ? invoice.item : [];
            const totals = items.reduce((acc, item) => {
              const batches = item.selectedBatches || [];
              batches.forEach((b) => {
                const line = (parseFloat(item.price || 0) * parseFloat(b.quantity || 0));
                const disc = ((item.discount || 0) / 100) * (item.price || 0) * (b.quantity || 0);
                acc.subtotal += line;
                acc.discount += disc;
              });
              return acc;
            }, { subtotal: 0, discount: 0 });
            const total = totals.subtotal - totals.discount;
            return (
              <div>
                <div>Subtotal: <strong>RM {totals.subtotal.toFixed(2)}</strong></div>
                <div>Discount: <strong>RM {totals.discount.toFixed(2)}</strong></div>
                <div style={{ marginTop: '6px' }}>Total Amount Payable : <strong>RM {total.toFixed(2)}</strong></div>
              </div>
            );
          })()}
        </div>

        <div style={{ marginBottom: '20px' }}>
          <div>Issued by:</div>
          <div style={styles.signatureLine}></div>
        </div>

        <div style={styles.notes}>
          <div>Notes :</div>
          <ol>
            <li>
              Please issue cheque made payable to : <strong>IPH PHARMACEUTICALS SDN BHD</strong><br />
              or transfer to our Maybank account no. : <strong>514048620937</strong><br />
              and inform us the details by email : <strong>finance.iphpsb@gmail.com</strong>
            </li>
            <li>Goods sold are not returnable or refundable.</li>
            <li>
              No complaints will be considered unless notified within (2) day upon receipt of the above
              mentioned items
            </li>
          </ol>
        </div>
      </div>
    );

    return (
      <>
        <div className="invoice-container">
          <Card style={styles.card} className="invoice-card" id="invoiceContent">
            <div style={styles.page} data-page="1">
              {renderHeader()}
              <div style={styles.title}>INVOICE / POISON ORDER</div>
              {renderClientInfo(1)}
              {renderItemsTable(
                {
                  np: groupedItems,
                  poison: groupedItems
                },
              )}
              {renderTotal()}
              {renderFooter()}
            </div>
          </Card>
        </div>
        {(orderInvoiceDetails?.autoCount_status === 'submitted' && orderInvoiceDetails?.status !== 'paid') && (
          <div className="text-center mt-4">
            <Button
              className="pay-now-button-bottom"
              onClick={() => { HandlePayment(orderInvoiceDetails) }}
              size="lg"
            >
              <FontAwesomeIcon icon={faMoneyBill} className="me-2" />
              {t("Pay Now")}
            </Button>
          </div>
        )}
      </>
    );
  };


  const renderPaymentsDetails = () => {
    const payment = orderPaymentDetails[0];
    if (!payment) return null;


    return (
      <div className="payment-receipt-container">
        <Card className="payment-receipt-card" id="paymentReceiptContent">
          <div className="payment-receipt-header">
            <Row>
              <Col md={8}>
                <img src={logo} alt="IPHRx" className="company-logo" />
                <p className="company-details">323, 1st Floor, Jalan Pudu, 55100 Kuala Lumpur, Wilayah Persekutuan , Malaysia</p>
                <p className="company-details">iphrx7@gmail.com</p>
                <p className="company-details">+60 1234567890</p>
              </Col>
              <Col md={4} className="text-end">
                <h1 className="payment-receipt-title">PAYMENT RECEIPT</h1>
                <table className="payment-info-table">
                  <tbody>
                    <tr>
                      <th>Order No.:</th>
                      <td>{payment.order_no || orderInvoiceDetails?.order_number || '-'}</td>
                    </tr>
                    <tr>
                      <th>Date:</th>
                      <td>{moment(payment.payment_date).format('DD/MM/YYYY')}</td>
                    </tr>
                    <tr>
                      <th>Status:</th>
                      <td>{payment.status}</td>
                    </tr>
                  </tbody>
                </table>
              </Col>
            </Row>
          </div>

          {/* Centered PAYMENT DETAILS heading spanning full width */}
          <div className="d-flex justify-content-center mt-2 mb-2" style={{ width: '100%' }}>
            <h3 className="section-title" style={{ margin: 0, textAlign: 'center' }}>PAYMENT DETAILS</h3>
          </div>

          <div className="payment-receipt-body">
            <Row>
              <Col md={6}>
                <div className="bill-to-section">
                  <h3 className="section-title">BILL TO</h3>
                  <p className="client-name">{rfqDetails?.userDetails?.[0]?.name}</p>
                  <p className="client-details">{rfqDetails?.userDetails?.[0]?.email}</p>
                  <p className="client-details">{rfqDetails?.userDetails?.[0]?.Address}</p>
                </div>
              </Col>
              <Col md={6}>
                <div className="payment-details-section text-end">
                  <p className="payment-details"><strong>Transaction ID:</strong> {payment.transition_id}</p>
                </div>
              </Col>
            </Row>



            <div className="payment-items">
              <table>
                <thead>
                  <tr>
                    <th>Order No.</th>
                    <th>Invoice No.</th>
                    <th>Paid Amount</th>
                    <th>Total Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{payment.order_no || orderInvoiceDetails?.order_number || '-'}</td>
                    <td>{payment.invoice_number}</td>
                    <td>RM {parseFloat(payment.amount).toFixed(2)}</td>
                    <td>RM {parseFloat(payment.total_amount).toFixed(2)}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="payment-summary">
              <Row>
                <Col md={8}>
                  <div className="payment-notes">
                    <h4>Notes</h4>
                    <p>Thank you for your payment</p>
                  </div>
                </Col>
                <Col md={4}>
                  <table className="summary-table">
                    <tbody>
                      <tr className="total-row">
                        <th>Total Paid:</th>
                        <td>RM {parseFloat(payment.amount).toFixed(2)}</td>
                      </tr>
                    </tbody>
                  </table>
                </Col>
              </Row>
            </div>
          </div>

          <div className="payment-receipt-footer">
            <p>If you have any questions about this payment, please contact us at <strong>finance.iphpsb@gmail.com</strong></p>
            <p>Thank you for your business</p>
          </div>
        </Card>



        <style>{`
          .payment-receipt-container {
            background-color: #f8f9fa;
            padding: 20px;
          }
          .payment-receipt-card {
            background-color: white;
            border: none;
            box-shadow: 0 0 30px rgba(0,0,0,0.1);
            padding: 40px;
            margin-bottom: 20px;
          }
          .payment-receipt-header {
            border-bottom: 2px solid #3D607A;
            padding-bottom: 20px;
            margin-bottom: 30px;
          }
          .company-logo {
            max-width: 150px;
            height: auto;
            margin-bottom: 5px;
          }
          .company-name {
            color: #3D607A;
            font-size: 24px;
            font-weight: 600;
            margin-bottom: 10px;
          }
          .company-details {
            color: #6c757d;
            margin: 0;
            line-height: 1.5;
          }
          .payment-receipt-title {
            color: #3D607A;
            font-size: 36px;
            font-weight: 700;
            margin: 0 0 20px 0;
          }
          .payment-info-table {
            width: 100%;
            margin-top: 10px;
          }
          .payment-info-table th, .payment-info-table td {
            padding: 1px;
            text-align: right;
          }
          .payment-info-table th {
            color: #3D607A;
            font-weight: 600;
            padding-right: 1px;
          }
          .payment-info-table td {
            padding-left: 1px;
          }
          .payment-receipt-body {
            margin-top: 30px;
          }
          .section-title {
            color: #3D607A;
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 15px;
            text-transform: uppercase;
          }
          .client-name {
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 5px;
          }
          .client-details, .payment-details {
            color: #6c757d;
            margin: 0;
            line-height: 1.5;
          }
          .payment-details-section {
            text-align: right;
          }
          .payment-items {
            margin-top: 30px;
            margin-bottom: 30px;
          }
          .payment-items table {
            width: 100%;
            border-collapse: separate;
            border-spacing: 0;
          }
          .payment-items th, .payment-items td {
            border: 1px solid #dee2e6;
            padding: 10px;
            text-align: left;
          }
          .payment-items th {
            background-color: #3D607A;
            color: white;
            font-weight: 600;
          }
          .payment-items tr:nth-child(even) {
            background-color: #f8f9fa;
          }
          .summary-table {
            width: 100%;
          }
          .summary-table th, .summary-table td {
            padding: 4px;
            text-align: right;
          }
          .summary-table th {
            color: #3D607A;
            font-weight: 600;
            padding-right: 1px;
          }
          .summary-table td {
            padding-left: 1px;
          }
          .total-row {
            font-size: 18px;
            font-weight: 700;
            color: #3D607A;
          }
          .payment-notes {
            background-color: #f8f9fa;
            border-left: 4px solid #3D607A;
            padding: 15px;
          }
          .payment-notes h4 {
            color: #3D607A;
            margin-bottom: 10px;
          }
          .payment-receipt-footer {
            margin-top: 40px;
            text-align: center;
            color: #6c757d;
            font-size: 14px;
          }
        `}</style>
      </div>
    );
  };




  const renderMessagingTab = () => (
    <Card className="mb-3">
      <CardBody className="p-0">
        <div className="chat-container">
          <div
            className="messages-container"
            ref={chatContainerRef}
          >
            {messages?.map((msg, index) => (
              <div key={index} className={`message-wrapper ${msg.sender_type === 'admin' ? 'received' : 'sent'}`}>
                <div className="message-content">
                  <div className="message-sender">{msg.sender_type === 'admin' ? 'admin' : 'doctor'}</div>
                  <div className="message-text">
                    {msg.message}
                  </div>
                  <div className="message-time">
                    {moment(msg.date).format('DD-MM-YYYY, h:mm A')}
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="message-input">
            <input
              type="text"
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  sendMessage();
                }
              }}
              placeholder="Type a message"
            />
            <Button color="primary" onClick={sendMessage}>
              <FontAwesomeIcon icon={faPaperPlane} />
            </Button>
          </div>
        </div>
      </CardBody>
    </Card>
  )


  const formatStatus = (status) => {
    if (!status) return '';

    // Replace underscores with spaces and capitalize each word
    return status
      .toLowerCase() // Ensure all letters are lowercase
      .split('_')    // Split by underscores
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter of each word
      .join(' ');    // Join the words with spaces
  };

  const getImageSrc = (item) => {
    if (item.itemDetails.Images && item.itemDetails.Images.length > 0) {
      const imageIndex = item.index || 0; // Use the provided index or default to 0
      const imageSrc = item.itemDetails.Images[imageIndex];

      // Check if the image is a base64 string
      if (imageSrc.startsWith('data:image')) {
        return imageSrc;
      } else {
        // If it's not a base64 string, assume it's a URL
        return imageSrc;
      }
    }
    return '';
  };

  const groupItemsByCategory = (items) => {
    return items?.reduce((acc, item) => {
      const category = item?.ItemGroup || item?.categoryDetails.Name;
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push(item);
      return acc;
    }, {});
  };

  const calculateTotals = (items) => {
    const subtotal = items?.reduce((total, item) => {
      const availableQuantity = item?.selectedBatches?.reduce((sum, batch) => sum + (batch.quantity), 0);
      return total + (availableQuantity * item?.price || 0);
    }, 0);

    const total_discount = items?.reduce((discount, item) => {
      const availableQuantity = item?.selectedBatches?.reduce((sum, batch) => sum + (batch.quantity), 0);
      return discount + (((item?.discount || 0) / 100) * (item?.price || 0) * (availableQuantity || 0));
    }, 0);

    const totalAmount = subtotal - total_discount;
    return { subtotal, discountPercentage: total_discount, totalAmount };
  };

  const renderItemRows = (items) => {
    const groupedItems = items?.reduce((acc, item) => {
      const category = item?.ItemGroup || item?.categoryDetails?.Name || '';
      if (!acc[category]) acc[category] = [];
      acc[category].push(item);
      return acc;
    }, {});

    return Object.entries(groupedItems).flatMap(([category, categoryItems]) =>
      categoryItems.map((item, itemIndex) => {
        const batches = item?.selectedBatches || [];
        const renderStack = (nodes) => (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>{nodes}</div>
        );

        return (
          <tr key={`${category}-${itemIndex}`}>
            <td>{itemIndex + 1}</td>
            <td>
              <div className="d-flex align-items-center justify-content-center flex-column">
                <strong>{item?.itemDetails?.item_name}</strong>
              </div>
            </td>
            <td>{item?.quantity}</td>
            <td>{item?.itemDetails?.BaseUOM || ''}</td>
            <td>{item?.price ? `RM ${parseFloat(item?.price).toFixed(2)}` : '-'}</td>
            <td>
              {item?.discount ? (
                renderStack(
                  batches.map((b, idx) => (
                    <span key={idx}>{`${(((item.discount || 0) / 100) * (item.price || 0) * (b.quantity || 0)).toFixed(2)} (${item.discount}%)`}</span>
                  ))
                )
              ) : (
                '-'
              )}
            </td>
            <td>
              {renderStack(batches.map((b, idx) => <span key={idx}>{b.batch_number || '-'}</span>))}
            </td>
            <td>
              {renderStack(batches.map((b, idx) => <span key={idx}>{b.quantity || '-'}</span>))}
            </td>
            <td>
              {renderStack(batches.map((b, idx) => <span key={idx}>{b?.expiry ? moment(b?.expiry).format('DD-MM-YYYY') : '-'}</span>))}
            </td>
            <td>
              {renderStack(
                batches.map((b, idx) => (
                  <span key={idx}>{`RM ${(
                    (parseFloat(item?.price || 0) * parseFloat(b?.quantity || 0)) -
                    (((item?.discount || 0) / 100) * (item?.price || 0) * (b?.quantity || 0))
                  ).toFixed(2)}`}</span>
                ))
              )}
            </td>
          </tr>
        );
      })
    );
  };

  const renderCreditNotesItems = (items) => {
    let rows = [];

    // Group items by category
    const groupedItems = items?.reduce((acc, item) => {
      const category = item?.ItemGroup || item?.categoryDetails?.Name || '';
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push(item);
      return acc;
    }, {});

    // Iterate through each category
    Object.entries(groupedItems).forEach(([category, categoryItems]) => {
      let isFirstItemInCategory = true;

      categoryItems.forEach((item, itemIndex) => {
        rows.push(
          <tr key={`${category}-${itemIndex}`}>
            {isFirstItemInCategory && (
              <td rowSpan={categoryItems.length}>
                {category}
              </td>
            )}
            <td>
              <div className="d-flex align-items-center">
                <span>{`${item?.item_name}(${item?.item_code})`}</span>
              </div>
            </td>
            <td>{item?.returned_quantity}</td>
            <td>{item?.price ? `RM ${parseFloat(item?.price).toFixed(2)}` : '-'}</td>
            <td>{`RM ${((item?.returned_quantity || 0) * (item?.price || 0)).toFixed(2)}`}</td>
          </tr>
        );

        isFirstItemInCategory = false;
      });
    });

    return rows;
  };

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case 'pending':
        return '#FFA500'; // Orange
      case 'Waiting for Approval':
        return 'red'; // Orange
      case 'confirmed':
        return '#4169E1'; // Royal Blue
      case 'processing':
        return '#9370DB'; // Medium Purple
      case 'in_transit':
        return '#1E90FF'; // Dodger Blue
      case 'delivered':
        return '#32CD32'; // Lime Green
      case 'cancelled':
        return '#DC143C'; // Crimson
      case 'order paid':
        return '#DC143C'; // Crimson
      case 'order received':
        return '#DC143C'; // Crimson
      default:
        return '#808080'; // Gray for unknown status
    }
  };

  const getIconForStatus = (status) => {
    switch (status.toLowerCase()) {
      case 'pending':
        return faClock;
      case 'confirmed':
        return faCheckCircle;
      case 'processing':
        return faSpinner;
      case 'in_transit':
        return faTruck;
      case 'delivered':
        return faBox;
      case 'cancelled':
        return faBan;
      case 'order paid':
        return faFire;
      case 'order received':
        return faClipboardList;
      default:
        return faQuestion;
    }
  };


  const renderTrackingContentDEMO = () => {
    if (!orderTrackingDetails || orderTrackingDetails?.length === 0) {
      return <div>No tracking information available</div>;
    }

    return (
      <div style={{
        backgroundColor: 'white',
        borderRadius: '10px',
        padding: '20px',
        boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
      }}>
        {orderTrackingDetails?.map((step, index) => (
          <div key={index} style={{
            display: 'flex',
            marginBottom: '20px',
            position: 'relative'
          }}>
            <div style={{
              width: '40px',
              height: '40px',
              backgroundColor: getStatusColor(step.status),
              borderRadius: '50%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginRight: '20px',
              zIndex: 1
            }}>
              <FontAwesomeIcon icon={getIconForStatus(step.status)} style={{ color: 'white' }} />
            </div>
            {index !== orderTrackingDetails.length - 1 && (
              <div style={{
                position: 'absolute',
                left: '20px',
                top: '40px',
                bottom: '-20px',
                width: '2px',
                borderLeft: `2px dashed ${getStatusColor(step.status)}`,
                zIndex: 0
              }} />
            )}
            <div style={{ flex: 1 }}>
              <h3 style={{ margin: '0 0 5px 0', color: getStatusColor(step.status) }}>{formatStatus(step.status)}</h3>
              <p style={{ margin: '0', color: '#666' }}>
                <FontAwesomeIcon icon={faClock} style={{ marginRight: '5px' }} />
                {moment(step.date_time).format('DD-MM-YYYY, h:mm:ss a')}
              </p>
            </div>
          </div>
        ))}
      </div>
    );
  };

  useEffect(() => {
    fetchMessages();
  }, [id, sessionID]);
  // Request notification permission once
  useEffect(() => {
    requestNotifyPermission();
  }, []);
  // Real-time updates: no polling; refresh on tab visibility and SW events only
  useEffect(() => {
    const onVisibility = () => {
      if (!document.hidden) {
        fetchMessages();
      }
    };
    const onSwMessage = (event) => {
      try {
        if (event?.data?.type === 'FCM_BACKGROUND_MESSAGE') {
          fetchMessages();
        }
      } catch (_) { }
    };
    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('message', onSwMessage);
    return () => {
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('message', onSwMessage);
    };
  }, [id, sessionID]);

  // Socket.io realtime subscription
  useEffect(() => {
    try {
      const s = io('/', { path: '/socket.io', transports: ['websocket'] });
      socketRef.current = s;
      if (id) s.emit('join_room', { orderId: id });
      s.on('order_message', (msg) => {
        setMessages((prev) => [...(prev || []), msg]);
        lastMessageCountRef.current = (lastMessageCountRef.current || 0) + 1;
        if (msg?.sender_type === 'admin') {
          pushNotify('New message from IPH', msg.message || 'You have a new message');
        }
      });
    } catch (_) { }
    return () => {
      try { socketRef.current?.disconnect(); } catch (_) { }
    };
  }, [id]);
  const chatContainerRef = useRef(null);

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [messages]);

  const fetchMessages = async () => {
    try {
      const response = await DiscountCouponService.GetOrderMessages(sessionID, id, 'doctor');
      if (response.data.message === "Unauthorized") {
        AuthService.logout();
        navigate("/login");
        window.location.reload();
      } else if (response.data) {
        const newMsgs = response.data.messages || [];
        const prevCount = lastMessageCountRef.current || 0;
        setMessages(newMsgs);
        if (prevCount && newMsgs.length > prevCount) {
          const lastMsg = newMsgs[newMsgs.length - 1];
          if (lastMsg?.sender_type === 'admin') {
            pushNotify('New message from IPH', lastMsg.message || 'You have a new message');
          }
        }
        lastMessageCountRef.current = newMsgs.length;
      }
    } catch (error) {
      console.error("Error fetching messages:", error);
    }
  };

  const sendMessage = async () => {
    if (newMessage.trim() === '') return;

    try {
      await DiscountCouponService.SendOrderMessage(sessionID, id, newMessage, 'doctor');
      setNewMessage('');
      fetchMessages(); // Refresh messages after sending
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  const formatCurrency = (value) => {
    const parsedValue = parseFloat(value);
    return !isNaN(parsedValue)
      ? parsedValue.toFixed(2)
      : '0.00';
  };

  const formatPaymentTerm = (paymentTerm) => {
    //iph todo: 47
    //console.log("paymentTerm", paymentTerm)

    if (!paymentTerm) return '';
    switch (paymentTerm.toLowerCase()) {
      case 'net-30':
        return 'Net 30 days';
      case 'net-60':
        return 'Net 60 days';
      case 'net-90':
        return 'Net 90 days';
      case 'advance':
        return 'C.O.D.';
      default:
        return paymentTerm;
    }
  };



  return (
    <>    <div className="app-main__outer">
      <div className="app-main__inner">
        <LoadingOverlay active={loading} spinner={<DNALoader />}>
          <div className="header">
            <Button color="link" className="p-0 text-decoration-none" onClick={() => navigate(-1)}>
              <FaArrowLeft className="me-2" />
              <span className="text-dark fw-bold">{t("Orders")}</span>
            </Button>

            <div className="actions">
              {activeTab === 'invoice_details' &&
                <Button disabled={orderInvoiceDetails?.autoCount_status !== 'submitted'} color="primary" onClick={downloadInvoice} className="accept-button">
                  <FaDownload className="me-2" />{orderInvoiceDetails?.autoCount_status !== 'submitted' ? "invoice is being generated and will be emailed once ready" : "Download Invoice"}
                </Button>
              }

              {activeTab === 'return' ?
                rfqDetails?.return_status ? rfqDetails?.return_status === "pending" ? (
                  <>
                    <button className="pending-button">{t("Return in Process")}</button>
                    {/* <button onClick={openPopup} className="accept-button">{t("Disapprove")}</button> */}
                  </>
                ) : rfqDetails?.return_status === "rejected" ? (
                  <button className="rejected-button">{t("Items Not Returned")}</button>
                ) : rfqDetails?.return_status === "accepted" ? (
                  <button className="accept-button">{t("Items Returned")}</button>
                ) : (
                  <button disabled className="pending-button">{t("Pending")}</button>
                )
                  :
                  <button disabled className="pending-button">{t("Return not Requested Yet")}</button>
                : ''
              }
              {activeTab === 'payment_details' &&
                <Button color="primary" onClick={downloadPaymentReceipt} className="accept-button">
                  <FaDownload className="me-2" /> Download Payment Receipt
                </Button>
              }
              {activeTab === 'credit_note' &&
                <Button color="primary" onClick={downloadCreditNote} className="accept-button">
                  <FaDownload className="me-2" /> Download Credit Note
                </Button>
              }

              {rfqDetails?.status === "Issued" ? (
                <>
                  <button onClick={openPopup} className="reject-button">{t("Reject")}</button>
                  <button onClick={handleAccept} className="accept-button">{t("Accept")}</button>
                </>
              ) : rfqDetails?.status === "accepted" || rfqDetails?.status === "confirmed" ? (
                <button className="accepted-button">{t("Quotation Accepted")}</button>
              ) : rfqDetails?.status === "rejected" || rfqDetails?.status === "cancelled" ? (
                <button className="rejected-button">{t("Quotation Rejected")}</button>
              ) : rfqDetails?.status === "Approved" ? (
                <button className="Approved-button">{t("Approved (Wait for Admin)")}</button>
              ) : rfqDetails?.status === "processing" ? (
                <button className="processing-button">{t("Processing")}</button>
              ) : rfqDetails?.status === "in_transit" ? (
                <button className="in-transit-button">{t("In Transit")}</button>
              ) : rfqDetails?.status === "Waiting for Approval" ? (
                <>
                  {/* <button onClick={openPopup} className="reject-button">{t("Reject")}</button> */}
                  <button onClick={handleApprove} className="approval-button">{t("Waiting for Approval")}</button>
                </>
              ) : rfqDetails?.status === "delivered" ? (
                <button className="delivered-button">{t("Delivered")}</button>
              ) : (
                <button disabled className="pending-button">{t("Pending")}</button>
              )}


            </div>

          </div>
          <h4 className="mb-4 fw-bold">{t("Order ID")} #{rfqDetails?.rfq_id}</h4>

          <div className="order-tabs mb-4">
            <button
              className={`tab-button ${activeTab === 'details' ? 'active' : ''}`}
              onClick={() => setActiveTab('details')}
            >
              <span className="tab-icon">📋</span>
              Details
            </button>
            {orderTrackingDetails?.length !== 0 &&
              <button
                className={`tab-button ${activeTab === 'tracking' ? 'active' : ''}`}
                onClick={() => setActiveTab('tracking')}
              >
                <span className="tab-icon">🚚</span>
                Order Tracking
              </button>
            }
            <button
              className={`tab-button ${activeTab === 'messaging' ? 'active' : ''}`}
              onClick={() => {
                setActiveTab('messaging')
                fetchMessages()
              }}
            >
              <span className="tab-icon">💬</span>
              Messages
            </button>
            {orderInvoiceDetails?.autoCount_status === 'submitted' && orderInvoiceDetails !== null &&
              <button
                className={`tab-button ${activeTab === 'invoice_details' ? 'active' : ''}`}
                onClick={() => setActiveTab('invoice_details')}
              >
                <span className="tab-icon">📄</span>
                Invoice
              </button>
            }
            {orderPaymentDetails?.length !== 0 &&
              <button
                className={`tab-button ${activeTab === 'payment_details' ? 'active' : ''}`}
                onClick={() => setActiveTab('payment_details')}
              >
                <span className="tab-icon">💳</span>
                Payment
              </button>
            }
            {rfqDetails?.status === 'delivered' && orderInvoiceDetails !== null &&
              <button
                className={`tab-button ${activeTab === 'return' ? 'active' : ''}`}
                onClick={() => setActiveTab('return')}
              >
                <span className="tab-icon">↩️</span>
                Return
              </button>
            }

            {orderCreditNoteDetails?.autoCount_status === 'submitted' && orderCreditNoteDetails &&
              <button
                className={`tab-button ${activeTab === 'credit_note' ? 'active' : ''}`}
                onClick={() => setActiveTab('credit_note')}
              >
                <span className="tab-icon">📝</span>
                Credit Note
              </button>
            }
          </div>
          {activeTab === 'details' && (
            <div className="details-tab">
              {renderOrderDetails()}
            </div>
          )}
          {activeTab === 'tracking' && renderTrackingContentDEMO()}
          {activeTab === 'credit_note' && renderCreditNoteTab()}
          {activeTab === 'messaging' && renderMessagingTab()}
          {activeTab === 'payment_details' && renderPaymentsDetails()}
          {activeTab === 'invoice_details' && renderInvoiceContent()}
          {activeTab === 'return' && renderReturnTab()}
        </LoadingOverlay>

      </div>
      <style>{`
.app-main__outer {
  background-color: #f8f9fa;
  min-height: 100vh;
  padding-top: 20px;
}
.return-tab-container {
  background-color: #f8f9fa;
  padding: 20px;
}
.return-card {
  background-color: white;
  border: none;
  box-shadow: 0 0 30px rgba(0,0,0,0.1);
  padding: 40px;
  margin-bottom: 20px;
}
.return-quantity-input {
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.return-quantity-input:focus {
  color: #495057;
  background-color: #fff;
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.rfq-card {
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  border: none;
}
.form-select, .form-control {
  border-color: #e0e0e0;
  background-color: red;
  border-radius: 5px;
  padding: 10px;
}
.btn-light {
  background-color: #ffffff;
  border-color: #e0e0e0;
  color: #333;
}
.btn-primary {
  background-color: #3D607A;
  border-color: #3D607A;
}
.text-muted {
  color: #6c757d !important;
}
h4, h5 {
  color: #333;
}
.item-list {
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  padding: 20px 0;
}
.item-image {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 5px;
}
.totals {
  margin-top: 20px;
}
.totals-row {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 5px;
}
.total-amount {
  font-weight: bold;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.back-button {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}
.rfq-id {
  font-weight: bold;
  font-size: 1.5rem;
}
.actions {
  display: flex;
  gap: 10px;
}
.reject-button, .rejected-button {
  background-color: #ffdddd;
  color: #d9534f;
  border: 1px solid #d9534f;
}
.accept-button, .accepted-button {
  background-color: #dff0d8;
  color: #5cb85c;
  border: 1px solid #5cb85c;
}
.pay-now-button {
  background-color: #5bc0de;
  color: white;
  border: 1px solid #46b8da;
}
.pay-now-button-bottom {
  background: linear-gradient(135deg, #3D607A 0%, #2d4a5c 100%);
  color: white;
  border: none;
  padding: 18px 48px;
  font-size: 20px;
  font-weight: 700;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(61, 96, 122, 0.4);
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
  min-width: 280px;
}
.pay-now-button-bottom:hover {
  background: linear-gradient(135deg, #2d4a5c 0%, #3D607A 100%);
  transform: translateY(-2px);
  box-shadow: 0 12px 32px rgba(61, 96, 122, 0.5);
}
.pay-now-button-bottom:active {
  transform: translateY(0);
  box-shadow: 0 4px 16px rgba(61, 96, 122, 0.3);
}
.processing-button {
  background-color: #fcf8e3;
  color: #8a6d3b;
  border: 1px solid #faebcc;
}
  .Approved-button {
  background-color: #fcf8e3;
  color:rgb(80, 127, 47);
  border: 1px solid #faebcc;
}
.in-transit-button {
  background-color: #d9edf7;
  color: #31708f;
  border: 1px solid #bce8f1;
}
  .approval-button {
  background-color: #d9edf7;
  color:rgb(213, 39, 39);
  border: 1px solid #bce8f1;
}
.delivered-button {
  background-color: #dff0d8;
  color: #3c763d;
  border: 1px solid #d6e9c6;
}
.pending-button {
  background-color: #f5f5f5;
  color: #777;
  border: 1px solid #ddd;
}
button {
  padding: 8px 16px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.3s ease;
}
button:hover:not(:disabled) {
  opacity: 0.8;
}
button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

/* Enhanced Tab Styling */
.order-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 32px;
  padding: 8px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 16px;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 20px rgba(61, 96, 122, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.tab-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border: none;
  border-radius: 12px;
  background: transparent;
  color: #64748b;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.tab-button:hover {
  background: rgba(61, 96, 122, 0.1);
  color: #3D607A;
  transform: translateY(-1px);
}

.tab-button.active {
  background: linear-gradient(135deg, #3D607A 0%, #2d4a5c 100%);
  color: #fff;
  box-shadow: 0 4px 16px rgba(61, 96, 122, 0.3);
  transform: translateY(-1px);
}

.tab-icon {
  font-size: 16px;
  opacity: 0.8;
}

.tab-button.active .tab-icon {
  opacity: 1;
}

/* Enhanced Table Styling - Only for Details tab */
.details-tab table {
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  background: rgba(255, 255, 255, 0.95);
  width: 100%;
}

.details-tab table thead th {
  background: linear-gradient(135deg, #3D607A 0%, #2d4a5c 100%);
  color: #fff;
  font-weight: 600;
  padding: 16px 12px;
  border: none;
  font-size: 14px;
  letter-spacing: 0.025em;
  text-align: center;
  position: relative;
}

.details-tab table thead th:first-child {
  border-top-left-radius: 12px;
}

.details-tab table thead th:last-child {
  border-top-right-radius: 12px;
}

.details-tab table tbody tr {
  transition: all 0.3s ease;
  border-bottom: 1px solid rgba(226, 232, 240, 0.5);
  background: rgba(255, 255, 255, 0.9);
}

.details-tab table tbody tr:hover {
  background: rgba(61, 96, 122, 0.05);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(61, 96, 122, 0.1);
}

.details-tab table tbody tr:last-child {
  border-bottom: none;
}

.details-tab table tbody tr:last-child td:first-child {
  border-bottom-left-radius: 12px;
}

.details-tab table tbody tr:last-child td:last-child {
  border-bottom-right-radius: 12px;
}

.details-tab table tbody td {
  padding: 16px 12px;
  border: none;
  font-size: 14px;
  color: #374151;
  vertical-align: middle;
  text-align: center;
}

/* Item name styling */
.details-tab table tbody td:first-child {
  font-weight: 600;
  color: #1f2937;
  text-align: center;
}

/* Quantity styling */
.details-tab table tbody td:nth-child(2) {
  text-align: center;
  font-weight: 500;
  color: #3D607A;
}

/* Price styling */
.details-tab table tbody td:nth-child(3),
.details-tab table tbody td:nth-child(8) {
  text-align: center;
  font-weight: 600;
  color: #059669;
}

/* Empty cell styling */
.details-tab table tbody td {
  color: #6b7280;
}

.details-tab table tbody td:contains("-") {
  color: #9ca3af;
  font-style: italic;
}

/* Enhanced Card Styling for item list in details tab */
.details-tab .item-list {
  background: rgba(248, 250, 252, 0.8);
  border-radius: 16px;
  padding: 24px;
  margin: 24px 0;
  border: 1px solid rgba(226, 232, 240, 0.8);
  box-shadow: 0 4px 20px rgba(61, 96, 122, 0.08);
}

.chat-container {
    background: linear-gradient(135deg, #3a7bd5, #3a6073);
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 600px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.chat-header {
    background-color: rgba(0, 0, 0, 0.2);
    color: #ffffff;
    padding: 15px;
    font-weight: bold;
    text-align: center;
    font-size: 1.2em;
}

.messages-container {
    flex-grow: 1;
    overflow-y: auto;
    padding: 15px;
    background-color: #F9F7F7;
}

.message-wrapper {
    display: flex;
    margin-bottom: 10px;
}

.message-wrapper.sent {
    justify-content: flex-end;
}

.message-wrapper.received {
    justify-content: flex-start;
}

.message-content {
    max-width: 60%;
    padding: 10px 15px;
    border-radius: 18px;
    position: relative;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.message-wrapper.sent .message-content {
    background-color: #00796B;
    color: white;
}

.message-wrapper.received .message-content {
    background-color: #1565C0;
    color: white;
}

.message-sender {
    font-weight: bold;
    margin-bottom: 4px;
    font-size: 0.9em;
    opacity: 0.8;
}

.message-text {
    margin-bottom: 4px;
    line-height: 1.4;
}

.message-time {
    font-size: 0.75em;
    opacity: 0.7;
    text-align: right;
}

.message-input {
    display: flex;
    align-items: center;
    padding: 15px;
    background-color: rgba(0, 0, 0, 0.2);
}

.message-input input {
    flex-grow: 1;
    border: none;
    border-radius: 20px;
    padding: 12px 20px;
    margin-right: 10px;
    background-color: rgba(255, 255, 255, 0.9);
    color: #333;
    font-size: 1em;
}

.message-input input::placeholder {
    color: #999;
}

.message-input button {
    background-color: #00796B;
    border: none;
    border-radius: 50%;
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.message-input button:hover {
    background-color: #00695C;
}
              `}</style>

    </div>
    </>
  );
};

export default ViewRfqs;
